

/**
 * 首页的异步菜单
 *需要根据用户角色动态加载的路由
 *没有roles:公共页面
 * roles: [] 存放可访问的角色 1：管理员 21：班主任(有科目) 20：班主任(无科目) 31：科任老师(有科目) 30：科任老师(无科目)
 */

const menuList = [
  {
    menuItemName: "系统管理",
    menuItemIcon: "curriculumManagement",
    childItem: [
      {
        itemName: "菜单管理",
        itemIcon: "caidanguanli",
        path: "/admin-menumanagement",
      },
      {
        itemName: "职务管理",
        itemIcon: "zhiwuguanli",
        path: "/admin-jobmanagement",
      },
      {
        itemName: "审核类型",
        itemIcon: "leave-type",
        path: "/audit-type",
      },
    ],
  },
  {
    menuItemName: "课程管理",
    menuItemIcon: "curriculumManagement",
    childItem: [
      {
        itemName: "课程编排",
        itemIcon: "curriculumManagement",
        path: "/curriculum",
      },
      {
        itemName: "课程表",
        itemIcon: "curriculumEdit",
        path: "/timetable",
      },
      {
        itemName: "值日表",
        itemIcon: "icon_zhirisheng",
        path: "/duty-arrangement",
      },
      {
        itemName: "调课申请",
        itemIcon: "tiaoke",
        path: "/course-djustment",
      },
    ],
  },
  {
    menuItemName: "学生管理",
    menuItemIcon: "studentManagement",
    childItem: [
      {
        itemName: "学生信息",
        itemIcon: "studentList",
        path: "/studentInfo",
      },
      {
        itemName: "免打扰",
        itemIcon: "noDisturb",
        path: "/no-disturb",
      },
      {
        itemName: "考勤管理",
        itemIcon: "kaoqinchuqin",
        path: "/attendance-class",
      },
      {
        itemName: "获奖情况",
        itemIcon: "huojiangrenyuan",
        path: "/awards",
      },
    ],
  },
  {
    menuItemName: "班级管理",
    menuItemIcon: "classManagement",
    // childItem: [
    //   {
    //     itemName: "绑定班级",
    //     itemIcon: "bindClass",
    //     path: "/bind-class",
    //   },
    // ],
  },
  {
    menuItemName: "学校管理",
    menuItemIcon: "admin-school",
    childItem: [
      {
        itemName: "学校信息",
        itemIcon: "admin-schoolinfo",
        path: "/admin-schoolinfo",
      },
      {
        itemName: "年级管理",
        itemIcon: "admin-grade",
        path: "/admin-grade",
      },
      {
        itemName: "课室管理",
        itemIcon: "admin-classroom",
        path: "/admin-classroom",
      },
      // {
      //   itemName: "信标管理",
      //   itemIcon: "admin-beacon",
      //   path: "/admin-beacon",
      //   roles: ['1'],
      // },
      {
        itemName: "教师管理",
        itemIcon: "admin-teacher",
        path: "/admin-teacher",
      },
      {
        itemName: "科目管理",
        itemIcon: "admin-course",
        path: "/admin-course",
      },
      {
        itemName: "学生管理",
        itemIcon: "studentList",
        path: "/admin-studentInfo",
      },
      {
        itemName: "课程编排",
        itemIcon: "curriculumManagement",
        path: "/admin-curriculum",
      },
      {
        itemName: "值日编排",
        itemIcon: "icon_zhirisheng",
        path: "/admin-duty-arrangement",
      },
      {
        itemName: "宿舍管理",
        itemIcon: "susheguanli",
        path: "/admin-dormitory",
      },
      {
        itemName: "教师分组",
        itemIcon: "classManagement",
        path: "/admin-teacher-group",
      },
      {
        itemName: "场馆管理",
        itemIcon: "changguanyuyue",
        path: "/admin-publicvenue",
      },
      {
        itemName: "学生导师",
        itemIcon: "daoshi",
        path: "/student-tutor",
      },
    ],
  },
  {
    menuItemName: "设备管理",
    menuItemIcon: "device-manage",
    // roles: [],
    childItem: [
      {
        itemName: "学生卡管理",
        itemIcon: "studentCard-manage",
        path: "/device-manage",
        // roles: [],
      },
      {
        itemName: "免打扰",
        itemIcon: "noDisturb",
        path: "/admin-noDisturb",
      },
    ],
  },
  {
    menuItemName: "作业管理",
    menuItemIcon: "homework-manage",
    // roles: [],
    childItem: [
      {
        itemName: "作业列表",
        itemIcon: "homework-list",
        path: "/homework-list",
        // roles: [],
      },
      {
        itemName: "发布作业",
        itemIcon: "publish-homework",
        path: "/publish-homework",
        // roles: [],
      },
    ],
  },
  {
    menuItemName: "请假管理",
    menuItemIcon: "leave-manage",
    // roles: [],
    childItem: [
      {
        itemName: "请假列表",
        itemIcon: "leave-list",
        path: "/leave",
        // roles: [],
      },
    ],
  },
  {
    menuItemName: "公告管理",
    menuItemIcon: "admin-notice",
    // roles: [],
    childItem: [
      {
        itemName: "通知公告",
        itemIcon: "admin-notice-list",
        path: "/notice",
        // roles: [],
      },
      {
        itemName: "实践活动",
        itemIcon: "huodong",
        path: "/practicalActivity",
      },
    ],
  },
  {
    menuItemName: "审核管理",
    menuItemIcon: "admin-examine",
    // roles: [],
    childItem: [
      {
        itemName: "审核列表",
        itemIcon: "admin-examine-list",
        path: "/examine",
        // roles: [],
      },
      {
        itemName: "审核结果",
        itemIcon: "admin-teacher",
        path: "/teacherExamine",
        // roles: [],
      },
      {
        itemName: "敏感词库",
        itemIcon: "tip",
        path: "/sensitiveWord",
      },
      // {
      //   itemName: "场馆预约",
      //   itemIcon: "changguanyuyue",
      //   path: "/admin-venueAppointment",
      // },
      {
        itemName: "调课审核",
        itemIcon: "tiaoke",
        path: "/admin-courseDjustment",
      },
      {
        itemName: "场馆预约",
        itemIcon: "changguanyuyue",
        path: "/venueAppointment",
      },
    ],
  },
  {
    menuItemName: "考试管理",
    menuItemIcon: "achievementManagement",
    // roles: [],
    childItem: [
      // {
      //   itemName: "考试信息",
      //   itemIcon: "releaseExam",
      //   path: "/admin-achievement",
      //   // roles: [],
      // },
      {
        itemName: "学生成绩",
        itemIcon: "studentAchievement",
        path: "/achievement",
        // roles: [],
      },
      {
        itemName: "成绩分析",
        itemIcon: "releaseExam",
        path: "/achievement-analysis-grade",
      },
      {
        itemName: "校外成绩",
        itemIcon: "homework-list",
        path: "/achievement-external",
      },
      {
        itemName: "学生标签",
        itemIcon: "student",
        path: "/achievement-student-tag",
      },
      {
        itemName: "选修成绩",
        itemIcon: "homework-list",
        path: "/elective-score-entry",
      },
    ],
  },
  {
    menuItemName: "个人中心",
    menuItemIcon: "user",
    childItem: [
      {
        itemName: "用户信息",
        itemIcon: "userInfo",
        path: "/userInfo",
        identification: 'userInfo',
      },
      {
        itemName: "修改手机",
        itemIcon: "phone",
        path: "/revisephone",
      },
      {
        itemName: "修改密码",
        itemIcon: "revise-password",
        path: "/revise-password",
      },
    ],
  },
]


function hasPermission(roleId, menu) {
  // if (menu.roles) {
  //   return menu.roles.includes(roleId) || menu.roles.includes(roleId.toString())
  // } else {
  //   return true
  // }
}

function filterAsyncRoutes(menuList, roleId) {
  const list = []

  // menuList.forEach(menu => {
  //   const tmp = { ...menu }
  //   if (hasPermission(roleId, tmp)) {
  //     if (tmp.childItem) {
  //       tmp.childItem = filterAsyncRoutes(tmp.childItem, roleId)
  //     }
  //     list.push(tmp)
  //   }
  // })
  // return list
}

export function getMenu(roleId) {
  // console.log(roleId)
  return new Promise(resolve => {
    let list = []
    // list = filterAsyncRoutes(menuList, roleId)
    resolve(menuList)
  })
}



export default menuList